import '../../../GenericContent/CardBlock/CardBlock.scss';
import './ContentCardBlock.scss';
import { createApp, defineAsyncComponent } from 'vue';

const CardBlockVideo = defineAsyncComponent(
	() => import('../../../GenericContent/CardBlock/CardBlockVideo.vue'),
);
const ContentCardCarousel = defineAsyncComponent(
	() => import('./components/ContentCardCarousel.vue'),
);

const mountingCardGridBlocks = document.querySelectorAll(
	'[data-feature="content-card-block"]',
);

if (mountingCardGridBlocks) {
	mountingCardGridBlocks.forEach((block) => {
		const app = createApp({
			name: 'ContentCardBlock',
		});
		app.component('card-block-video', CardBlockVideo);
		app.component('content-card-carousel', ContentCardCarousel);
		app.mount(block);
	});
}

